<template>
    <v-card elevation="3" class="marketing-wrapper-right">
        <v-card-title class="section-title">Agenturen mit unbenutzten Slots</v-card-title>
        <v-divider class="divider-styling"></v-divider>
        <div class="search-wrapper">
            <v-text-field v-model="amountFreeSlots" class="search-text-field" variant="outlined" density="compact"
                hide-details type="Number" label="Zahl der offenen Slots"></v-text-field>
            <v-btn class="gradient-color-primary" rounded="lg" :loading="loadingState" variant="outlined" @click="fetchAgenciesWithFreeSlots"
                prepend-icon="mdi-database-search-outline">Laden</v-btn>
        </div>
        <v-data-table density="compact" class="data-table" :loading="loadingState"
            :items="agenciesWithFreeSlots" item-key="_id">
            <template v-slot:item="{ item }">
                <tr class="data-table-results" @click="openAgencyDialog(item)">
                    <td>{{ item._id }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.freeSlots }}</td>
                </tr>
            </template>
        </v-data-table>
        <AgencyDialog v-if="selectedAgency._id" :agencyId="selectedAgency._id"></AgencyDialog>
    </v-card>
</template>

<script>
import axios from 'axios';
import AgencyDialog from '@/components/AgencyDialog.vue';
import { mapMutations } from 'vuex';

export default {
    data() {
        return {
            agenciesWithFreeSlots: [],
            amountFreeSlots: 11,
            loadingState: false,
            selectedAgency: {},
        };
    },
    watch: {
        agencyDialog(newVal) {
            if (!newVal) {
                this.selectedAgency = {};
            }
        }
    },
    methods: {
        async fetchAgenciesWithFreeSlots() {
            try {
                this.loadingState = true;
                const token = this.$store.state.loginAndOut.token;

                const response = await axios.get(`/api/statistics/getAgenciesWithAmountFreeSlots`, {
                    params: {
                        amountFreeSlots: this.amountFreeSlots
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.status === 200) {
                    this.agenciesWithFreeSlots = response.data;
                    this.loadingState = false;
                } else {
                    this.loadingState = false;
                    throw new Error('Failed to fetch data');
                }
            } catch (error) {
                this.loadingState = false;
                console.error('Error:', error);
            }
        },
        ...mapMutations('agency', ['setDialogReturnRoute']),
        openAgencyDialog(item) {
            this.selectedAgency = item;
            this.$store.dispatch("agency/setDialogReturnRoute", this.$route.fullPath);
            this.$router.push({ name: 'agency', params: { agencyId: this.selectedAgency._id } });
        }
    },
    components: {
        AgencyDialog
    }
};
</script>

<style lang="scss" scoped>
.search-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    gap: 12px;
}

.search-text-field {
    width: 100%;
}

.section-title {
    font-size: 20px;
    font-weight: 500;
    padding-left: 4px;
}

.divider-styling {
    margin-bottom: 16px;
}

.data-table {
    border: 1px solid #ccc;
    border-radius: 12px;
}

.data-table-results {
    cursor: pointer;
}

</style>